import Component from 'vue-class-component'
import moduleStore from './store/order';
import Vue from 'vue';
import PageState from './store/state';
import exportPopup from "@/views/videoEditor/components/exportPopup/exportPopup";
import {getQueryString} from "@/utils/location";
import { judgeDeviceType } from "@/utils/device";

@Component({
    components: {
        exportPopup,
    }
})
@moduleStore.initVuex({
    mutationNames: moduleStore.mutationNames,
    actionNames: moduleStore.actionNames
})
export default class orderPage extends Vue implements IvuePage<PageState>{
    state = new PageState();
    self:Vue = this;
    styles= [];
    type='全部类型';
    date='全部日期';
    dateValue='全部日期';
    activeKey:any=0;
    activeValue='全部类型';
    minDate = new Date('2000-01-01')
    showTypesPopover:boolean=false;
    showDatePopover:boolean=false;
    show=false;
    loading:Boolean=false;
    finished:Boolean=true;
    works=[];
    isShowExportPopup:boolean=false;
    subtitleInfo={
        articleId:''
    };
    isApp = judgeDeviceType.isAPP;
    // 分页查询 page params
    pageSize: number = 10
    currentPage: number = 1
    totalPages: number = 1

    created(moduleData: IinjectDatas) {
        this.state = <PageState>moduleData.state;
    }
    mounted(moduleData: IinjectDatas){
        const ww_token = getQueryString('ww_token') ||localStorage.getItem("ww_token");
        if (!ww_token) {
            // this.$navigateTo({
            // 	url:'/pages/login/login'
            // })
        }else{
            this.reloadWorks()
            this.getStyles()
        }
    }
    //选择一种类型
    choose(item, key){
        this.activeKey = key;
    }
    //重置所有
    resetFilters(){
        this.activeType = ''
        this.date='全部日期';
        this.dateValue='全部日期';
        this.activeKey=0;
        this.activeValue=this.styles[this.activeKey].name;
        this.reloadWorks()
    }
    getStyles(){
        this.$http('getTransactionStyle')
            .then(res=> {
                if(res.code==200){
                    this.styles = res.data
                    this.styles.unshift({
                        'code':  '',
                        'name': "全部类型"
                    });
                }
            })
    }
    upLoadData(){
        if(this.currentPage <= this.totalPages) {
            this.currentPage = this.currentPage + 1
            this.loading = true
            this.finished = false
            this.getWorks();
        }
    }
    reloadWorks(){
        this.currentPage = 1
        this.totalPages = 1
        this.loading = true
        this.finished = false
        this.getWorks()
    }
    getWorks() {
        let startDate = this.date.split('+')[0]
        let endDate = this.date.split('+')[1]
        let params={
            size: this.pageSize,
            page: this.currentPage,
            startDate: startDate === '全部日期' ? '' : startDate,
            endDate: endDate === '全部日期' ? '' : endDate
        }
        if (this.activeType) {
            params['project'] = this.activeType
        }
        this.$http("getTransactionList", params).then(res=>{
            const { code, data, message } = res
            if (code === 200) {
                const results = data.results || []
                this.totalPages = data.total_pages
                this.works = this.currentPage === 1
                    ? results
                    : [ ...this.works, ...results ]
                // 是否还有更多
                this.finished = this.currentPage >= this.totalPages
            } else {
                this.$toast(message)
                this.currentPage = 1
                this.finished = true
            }
            this.loading=false
        })
    }

    //重置
    reset(){
        this.activeKey=0;
        this.activeValue=this.styles[this.activeKey].name;
        if(this.showTypesPopover){
            this.type = '全部类型';
        }else{
            this.date='全部日期';
            this.dateValue='全部日期';
        }
        this.showTypesPopover=false;
        this.showDatePopover=false;
        this.reloadWorks();
    }
    //选择类型-完成
    finishType() {
        this.showTypesPopover = false;
        this.type = this.styles[this.activeKey].nameEN;
        this.activeValue=this.styles[this.activeKey].name;
        this.reloadWorks();
    }
    //选择日期完成
    finishDate(){
        this.showDatePopover = false;
        if (this.activeKey === 0) {
            this.date='全部日期'
            this.dateValue='全部日期'
        }
        this.reloadWorks();
    }
    //格式化日期
    formatDate(date,type) {
        let year=date.getFullYear();
        let month=date.getMonth() + 1<10?'0'+(date.getMonth() + 1):date.getMonth() + 1;
        let day=date.getDate()<10?'0'+date.getDate():date.getDate();
        return type=='dot'?`${year}.${month}.${day}`:`${year}-${month}-${day}`;
    }
    //选中日期
    onConfirmDate(date){
        this.show = false;
        this.showDatePopover=false;
        this.date = this.formatDate(date[0],'')+'+'+this.formatDate(date[1],'');
        this.dateValue=this.formatDate(date[0],'dot')+'-'+this.formatDate(date[1],'dot')
        this.reloadWorks();
    }

    /** 修改类型选择弹窗状态 */
    changeTypePopoverState() {
        this.showTypesPopover = !this.showTypesPopover
        this.showDatePopover = false
    }

    /** 修改时间选择弹窗状态 */
    changeDatePopoverState() {
        this.showDatePopover = !this.showDatePopover
        this.showTypesPopover = false
    }

    /****************************** 消费记录类型选择 ******************************/

    /** 从消费类型列表中获取消费类型中文名称 */
    getTypeNameFromList(type: string) {
        let typeName = '全部类型'
        for (let i = 0; i < this.styles.length; i++) {
            const item = this.styles[i]
            if (type === item.code) {
                typeName = item.name
            }
        }
        return typeName
    }

    // 当前选择的消费类型
    activeType: string = ''
    /** 选择消费类型 */
    selectType(type: string) {
        if (this.activeType === type) return
        this.activeType = type
    }
    /** 初始化选择的类型 */
    resetType() {
        this.activeType = ''
        this.showTypesPopover = false
        this.reloadWorks()
    }
    /** 确认选择类型 */
    confirmSelectType() {
        this.showTypesPopover = false
        // 重新加载列表
        this.reloadWorks()
    }

}